<template>
    <v-card flat class="">
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Kelompok</th>
                        <th>Stase</th>
                        <th>File</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in table.items" :key="item.id">
                        <td>{{ key + 1 }}</td>
                        <td>{{ item.profesi }}</td>
                        <td>{{ item.nama_stase }}, {{ item.stase }}</td>
                        <td>
                            <embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'"
                                width="500" height="300" />
                            <br /><a target="_blank" :href="item.file_url">Lihat
                                File</a>
                        </td>
                        <td>
                            <span v-if="item.flag_end == 0">Aktif</span>
                            <span v-else>Non Aktif</span>
                        </td>
                        <td>
                            <span v-if="item.flag_end == 0">
                                <span v-if="user.profesi == 'Dokter'">
                                    <router-link :to="{ name: 'UserDaftarHadir', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Daftar Hadir</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserLogbook', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Logbook</v-btn>
                                    </router-link>
                                    <router-link
                                        :to="{ name: 'UserTingkatSupervisi', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Tingkat Supervisi</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserLaporanJaga', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Laporan Jaga</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserBst', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>BST</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserUjian', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Ujian</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserJurnalReading', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Jurnal Reading</v-btn>
                                    </router-link>
                                </span>
                                <span v-if="user.profesi == 'PPDS'">
                                    <router-link :to="{ name: 'UserDaftarHadir', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Daftar Hadir</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserLogbook', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Logbook</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserTargetKompetensi', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Target Kompetensi</v-btn>
                                    </router-link>
                                </span>
                                <span v-if="user.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'">
                                    <router-link :to="{ name: 'UserDaftarHadir', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Daftar Hadir</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserLogbook', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Logbook</v-btn>
                                    </router-link>
                                    <router-link
                                        :to="{ name: 'UserTingkatSupervisi', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Tingkat Supervisi</v-btn>
                                    </router-link>
                                    <router-link :to="{ name: 'UserUjian', params: { praktik_id: item.id } }">
                                        <v-btn block class="my-2" small color="primary" dark>Ujian</v-btn>
                                    </router-link>
                                </span>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import PilihMultiUser from '@/views/PilihMultiUser.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil, mdiEye } from '@mdi/js'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        PilihMultiUser,
    },
    data() {
        return {
            data: {
                nama_institusi: '',
                nama_prodi: '',
                profesi: '',
                stase: '',
                tanggal_awal: '',
                tanggal_akhir: '',
            },
            icons: {
                mdiDelete,
                mdiPencil, mdiEye
            },
            tableOptions: {},
            table: {
                loading: true,
                items: [],
                totalItems: 0,
            },
            dialog: false,
            form: {
                editedIndex: -1,
                editedItem: {
                    role: '',
                    selectedUsers: [],
                },
                defaultItem: {
                    role: '',
                    selectedUsers: [],
                },
                roles: [
                    'PESERTA DIDIK', 'PEMBIMBING KLINIK'
                ],
                users: [],
            },
        }
    },
    watch: {
    },
    computed: {
        formTitle() {
            return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
        },
        user() {
            return this.$store.getters.user
        },
    },
    created() {
        this.getPraktikUser()
    },
    methods: {
        save() {
            if (this.form.editedIndex > -1) {
            } else {
                const fmData = new FormData()
                fmData.append('praktik_id', this.praktik_id)
                fmData.append('role', this.form.editedItem.role)
                fmData.append('users', this.form.editedItem.selectedUsers)
                axiosPostAuth('api/Praktik/addUserPraktik', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                            this.dialog = false
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        },
        getPraktikUser() {
            const fmData = new FormData()
            axiosPostAuth('api/Praktik/getPraktikUser', fmData)
                .then(response => {
                    this.table.items = response.data
                })
                .catch(error => {
                    alert(error)
                })
        },
        getDetail() {
            const fmData = new FormData()
            fmData.append('id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPraktik', fmData)
                .then(response => {
                    this.data = Object.assign({}, response.data)
                })
                .catch(error => {
                    alert(error)
                })
        },
        deleteItem(item) {
            const conf = confirm("Apakah yakin akan dihapus?")
            if (conf) {
                const fmData = new FormData()
                fmData.append('id', item.id)
                axiosPostAuth('api/Praktik/deleteUserPraktik', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        },
    },
}
</script>